import Vue from 'vue';
import axios from 'axios';
import store from '../../store';
import router from '../../router';

const $ajax = axios.create();// 修改名称  抽取所有的URL作为一个配置对象
Vue.prototype.$ajax = $ajax;
// ajax缓冲动画

const loading = document.getElementsByClassName('loadingWrap')[0];
const body = document.getElementsByTagName('body')[0];

// 向服务器发出请求时
$ajax.interceptors.request.use(config => {
  loadingShow();
  store.commit('changeLoadingState', true);
  if (localStorage.JWT_TOKEN) { // 本地存在时 添加表头x-access-token
    config.headers['Authorization'] = `${localStorage.JWT_TOKEN}`;
  }
  const prefixProtocol = ((document.location.protocol == 'https:') ? ' https://' : ' http://');// 根据环境配置协议
  config.url = prefixProtocol + process.env.VUE_APP_HOST + config.url;
  return config;
}, err => {
  console.error(err);
});

// 数据返回时
$ajax.interceptors.response.use(function (response) { // 对返回的数据进行一些处理
  store.commit('changeLoadingState', false);
  loadingHide();
  loading.className = 'loadingWrap';
  body.setAttribute('style', 'overflow: scroll');
  if (response.status == 200 && response.data.status == 401) {
    Vue.prototype.$Message.warning('当前用户登录信息已过期，请重新登录！');
    router.push({ path: '/login' });
  }
  if (response.status == 200 && response.data.status != 200) {
    Vue.prototype.$Message.warning(response.data.msg);
  }
  return response;
}, (error) => {
  store.commit('changeLoadingState', false);
  loadingHide();
  console.log(error);
  if (error.response && error.response.data && error.response.data.code) {
    if (error.response.data.status == 401 || error.response.data.status == 402 || error.response.data.status == 403) {
      localStorage.JWT_TOKEN = '';
      localStorage.YK_TICKET = '';
      if (!localStorage.YK_TICKET) {
        window.location.href = casOut;
      }
      if (error.response.data.status == 402) {
        Vue.prototype.$Message.warning('当前用户登录信息已过期，请重新登录！');
        router.push({ path: '/login' });
      } else {
        Vue.prototype.$Message.warning(error.response.data.msg || '服务器响应异常（状态：002），请重新登录系统！');
        router.push({ path: '/login' });
      }
    } else if (error.response.data.msg) {
      alert(error.response.data.msg);
    } else {
      alert('服务器响应异常（状态：001），请刷新页面，重新尝试！');
    }
  } else {
    alert('网络异常，请重新操作');
    // window.location.reload(); // 兼容Safari 取消ajax的情况
  }
  return Promise.reject(error);
});
function loadingShow () { // 显示loading效果
  loading.className = 'loadingWrap active';
  body.setAttribute('style', 'overflow: hidden');
}
function loadingHide () { // 隐藏loading效果
  if (store.state.axios.loadingCount <= 0) {
    loading.className = 'loadingWrap';
    body.setAttribute('style', 'overflow: scroll');
  }
}
export default $ajax;
